package com.kinoshazam.screens.search.expanded

import androidx.compose.runtime.Composable
import presentation.screens.search.SearchMVIAction
import presentation.screens.search.SearchState

@Composable
actual fun ExpandedSearchWindow(
    state: SearchState,
    onAction: (SearchMVIAction) -> Unit,
) {
}